import PropTypes from 'prop-types';

import { PM_ACCENT_DEFAULT, pmPageFlags } from '../../constants/pmDesign';
import { derivePalette } from '../../utils/pmColor';

/**
 * Tiny A4 preview shown on each gallery card. Pure decoration — no real content.
 * Works defensively with partial designData: the palette is read from the page
 * theme, falling back to a derived default so templates without complete colours
 * still render.
 */
export default function LetterThumbnail({ tpl }) {
	const theme =
		tpl?.theme?.primary && tpl?.theme?.soft ? tpl.theme : derivePalette(tpl?.theme?.primary || PM_ACCENT_DEFAULT);
	const { hasSidebar: isSidebar, hasFooter } = pmPageFlags(tpl);
	const sidebarVariant = tpl?.layout === 'coloredSidebar' ? 'colored' : 'light';

	return (
		<div className="pm-thumb" style={{ '--mini-primary': theme.primary, '--mini-soft': theme.soft }}>
			<div className="pm-thumb__head">
				<div className="pm-thumb__logo" style={{ background: theme.primary }} />
				<div className="pm-thumb__stamp">MUSTER</div>
			</div>
			<div className="pm-thumb__body">
				<div className="pm-thumb__main">
					<div className="pm-thumb__address">
						<div />
						<div />
						<div />
					</div>
					<div className="pm-thumb__line pm-thumb__line-title" />
					<div className="pm-thumb__line" />
					<div className="pm-thumb__line" />
					<div className="pm-thumb__line w70" />
					<div className="pm-thumb__line" />
					<div className="pm-thumb__line w50" />
				</div>
				{isSidebar && (
					<div className={`pm-thumb__side pm-thumb__side--${sidebarVariant}`}>
						<div className="pm-thumb__cta" />
						<div className="pm-thumb__photos">
							<div />
							<div />
							<div />
						</div>
						<div className="pm-thumb__line side w80" />
						<div className="pm-thumb__line side w60" />
					</div>
				)}
			</div>
			{hasFooter && <div className="pm-thumb__foot" />}
		</div>
	);
}

LetterThumbnail.propTypes = {
	tpl: PropTypes.object.isRequired,
};
